module.exports = __webpack_public_path__ + "img/Prochainement.93b120db.png";